export enum EffectifMode {
  Prevision = 1,
  Fabrication = 2,
  Facturation = 3
}

